import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@frontend/shadcn/components/ui/select';

interface FontOption {
  value: string;
  label: string;
}

const FONT_OPTIONS: FontOption[] = [
  { value: "'Inter', sans-serif", label: 'Inter' },
  { value: 'Arial, Helvetica, sans-serif', label: 'Arial' },
  { value: 'Verdana, Geneva, sans-serif', label: 'Verdana' },
  { value: 'Tahoma, Geneva, sans-serif', label: 'Tahoma' },
  { value: "'Trebuchet MS', Helvetica, sans-serif", label: 'Trebuchet MS' },
  { value: "'Times New Roman', Times, serif", label: 'Times New Roman' },
  { value: 'Georgia, serif', label: 'Georgia' },
  { value: "'Garamond', serif", label: 'Garamond' },
  { value: "'Courier New', Courier, monospace", label: 'Courier New' },
  { value: "'Lucida Console', Monaco, monospace", label: 'Lucida Console' },
  { value: 'Impact, Charcoal, sans-serif', label: 'Impact' },
];

export interface FontPickerProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  id?: string;
  triggerClassName?: string;
  contentClassName?: string;
  disabled?: boolean;
}

export const FontPicker: React.FC<FontPickerProps> = ({
  value,
  onChange,
  placeholder = 'Select a font',
  id,
  triggerClassName,
  contentClassName,
  disabled = false,
}) => {
  const selectedFontOption = FONT_OPTIONS.find((font) => font.value === value);
  const triggerValueStyle = value && selectedFontOption ? { fontFamily: `${selectedFontOption.value} !important` } : {};

  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger id={id} className={triggerClassName}>
        <SelectValue placeholder={placeholder} style={triggerValueStyle} />
      </SelectTrigger>
      <SelectContent className={contentClassName}>
        {FONT_OPTIONS.map((font) => (
          <SelectItem
            key={font.value}
            value={font.value}
          >
            <span style={{ fontFamily: font.value }}>
              {font.label}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
